import { TARGET_ENV } from '~config/publicEnv';

const SENDBIRD_APP_ID_MAP: Record<string, string> = {
  dev: 'DC591A53-B567-4082-83A4-E8B550A3E4AE',
  dev01: 'DC591A53-B567-4082-83A4-E8B550A3E4AE',
  dev02: 'DC591A53-B567-4082-83A4-E8B550A3E4AE',
  test: '6C7CD015-85C6-4811-93D7-C808776B220F',
  test01: '6C7CD015-85C6-4811-93D7-C808776B220F',
  test02: '6C7CD015-85C6-4811-93D7-C808776B220F',
  stage: '85D30E6C-3FE3-42B9-97FD-967AD829FA3E',
  production: '85D30E6C-3FE3-42B9-97FD-967AD829FA3E',
};

export const SENDBIRD_APP_ID = SENDBIRD_APP_ID_MAP[TARGET_ENV] ?? SENDBIRD_APP_ID_MAP.dev;
